import React, { useState, useEffect, useRef } from "react";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Popup, Form, Button, Pager, Paging, GroupPanel, SearchPanel, Grouping, RemoteOperations, MasterDetail } from "devextreme-react/data-grid";
import ItemProperties from "../../components/itemProperties/ItemProperties";
import { useDispatch } from 'react-redux';
import { Label } from "devextreme-react/form";
import { CommonSeriesSettingsHoverStyle } from "devextreme-react/chart";
import Title from "../../components/shared/Title";
import BlockHeader from "../../components/shared/BlockHeader";
import { openThisDialog } from '../../store/dialog/dialogReducer';
import { openEditDialog } from "../../store/editDialog/editDialogReducer";
import AddCatalogEntryDialog from "./AddCatalogEntryDialog";
import EditCatalogEntryDialog from "./EditCatalogEntryDialog";
import DetailTemplate from "./DetailTemplate";
import { catalogosConocidos } from "../../data/catalogos";
import { Tabs, Tab, TabList, TabPanel } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import CatalogGroup from "./CatalogGroup";
import { tipoArticulos } from "../../data/catalogos"

const descriptionEditorOptions = { height: 100 };



const MasterCatalogs = props => {
    const { search } = props.location;
    const tabIndexInit = search ? parseInt(search.substring(3)) : 0;

    let dispatch = useDispatch();
    const gridRef = useRef();
    const [item, setItem] = useState([]);

    const [tabIndex, setTabIndex] = useState(tabIndexInit);



    useEffect(() => {
        onLoad();
    }, []);


    const onLoad = () => {
        http(uri.catalogNames).asGet().then
            (data => {
                setItem(data.map(x => { return { catalog: x, description: getDescription(x) } }))
            });
    };

    const refreshGrid = () => {
        // gridRef.current.instance.refresh();
        onLoad();
    }

    const getDescription = (c) => {
        switch (c) {
            case catalogosConocidos.AlturaMarco:
                return 'Altura';
            case catalogosConocidos.Color:
                return 'Color';
            case catalogosConocidos.MarcaAccesorio:
                return 'Marca';
            case catalogosConocidos.MarcaLenteContacto:
                return 'Marca';
            case catalogosConocidos.MarcaLenteOftalmico:
                return 'Marca';
            case catalogosConocidos.MarcaMarcoAro:
                return 'Marca';
            case catalogosConocidos.ModeloMarcoAro:
                return 'Modelo';
            case catalogosConocidos.Material:
                return 'Material';
            case catalogosConocidos.ModeloLenteOftalmico:
                return 'Modelos';
            case catalogosConocidos.ModeloLenteContacto:
                return 'Modelo';
            case catalogosConocidos.SubTipoLente:
                return 'SubTipo de Lente';
            case catalogosConocidos.SubTipoMantenimiento:
                return 'SubTipo de Mantenimiento';
            case catalogosConocidos.TipoLente:
                return 'Tipo de Lente';
            case catalogosConocidos.TipoLenteContacto:
                return 'Tipo de Lente de Contacto';
            case catalogosConocidos.TipoMarco:
                return 'Tipo de Marco';
            case catalogosConocidos.Tratamiento:
                return 'Tratamiento';

            case catalogosConocidos.MarcaLentesEsclerales:
                return 'Marca';
            case catalogosConocidos.ModeloLentesEsclerales:
                return 'Modelo';
            case catalogosConocidos.TipoLentesEsclerales:
                return 'Tipo de Lentes Esclerales';
            case catalogosConocidos.DisenoLenteEsclerales:
                return 'Diseño de Lentes Esclerales';

            default:
                return c;
        }
    }

    const lentesOftalmicos = [
        catalogosConocidos.TipoLente,
        catalogosConocidos.Tratamiento,
        catalogosConocidos.Material,
        catalogosConocidos.MarcaLenteOftalmico,
        catalogosConocidos.ModeloLenteOftalmico,
        //  catalogosConocidos.SubTipoLente,
        catalogosConocidos.Color
    ];

    const lentesContacto = [
        catalogosConocidos.MarcaLenteContacto,
        catalogosConocidos.ModeloLenteContacto,
        catalogosConocidos.TipoLenteContacto
    ];

    const marcoAro = [
        catalogosConocidos.MarcaMarcoAro,
        catalogosConocidos.ModeloMarcoAro,
        catalogosConocidos.TipoMarco,
        catalogosConocidos.AlturaMarco,
        catalogosConocidos.Color
    ];

    const mantenimiento = [
        catalogosConocidos.SubTipoMantenimiento
    ];

    const accesorios = [
        catalogosConocidos.MarcaAccesorio
    ];

    const lentesEsclerales = [
        catalogosConocidos.MarcaLentesEsclerales,
        catalogosConocidos.ModeloLentesEsclerales,
        catalogosConocidos.TipoLentesEsclerales,
        catalogosConocidos.DisenoLenteEsclerales
    ];



    const getCatalogSource = (typeId) => {


        switch (typeId) {
            case tipoArticulos.LentesOftalmicos:
                return item.filter(x => lentesOftalmicos.indexOf(x.catalog) != -1).sort((a, b) => lentesOftalmicos.indexOf(a.catalog) - lentesOftalmicos.indexOf(b.catalog));
            case tipoArticulos.LentesDeContacto:
                return item.filter(x => lentesContacto.indexOf(x.catalog) != -1).sort((a, b) => lentesContacto.indexOf(a.catalog) - lentesContacto.indexOf(b.catalog));
            case tipoArticulos.MarcoAro:
                return item.filter(x => marcoAro.indexOf(x.catalog) != -1).sort((a, b) => marcoAro.indexOf(a.catalog) - marcoAro.indexOf(b.catalog));
            case tipoArticulos.Mantenimiento:
                return item.filter(x => mantenimiento.indexOf(x.catalog) != -1);
            case tipoArticulos.Accesorios:
                return item.filter(x => accesorios.indexOf(x.catalog) != -1);
            case tipoArticulos.LentesEsclerales:
                return item.filter(x => lentesEsclerales.indexOf(x.catalog) != -1);
            default:
                return item;
        }
    }

    const title = 'Lista de catalogos'

    return (
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} />
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <AddCatalogEntryDialog updateParent={refreshGrid}></AddCatalogEntryDialog>
                    <EditCatalogEntryDialog></EditCatalogEntryDialog>

                    <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>

                        <TabList>
                            <Tab>Lentes Oftalmicos</Tab>

                            <Tab>Marco/Aro</Tab>
                            <Tab>Lentes de contactos</Tab>
                            <Tab>Accesorios</Tab>
                            {/* <Tab>Servicios</Tab> */}
                            <Tab>Lentes Esclerales</Tab>


                        </TabList>

                        <TabPanel>
                            <CatalogGroup catalogSource={getCatalogSource(tipoArticulos.LentesOftalmicos)} />
                        </TabPanel>

                        <TabPanel>
                            <CatalogGroup catalogSource={getCatalogSource(tipoArticulos.MarcoAro)} />
                        </TabPanel>

                        <TabPanel>
                            <CatalogGroup catalogSource={getCatalogSource(tipoArticulos.LentesDeContacto)} />
                        </TabPanel>

                        <TabPanel>
                            <CatalogGroup catalogSource={getCatalogSource(tipoArticulos.Accesorios)} />
                        </TabPanel>

                        {/* <TabPanel>
                            <CatalogGroup catalogSource={getCatalogSource(tipoArticulos.Mantenimiento)} />
                        </TabPanel> */}

                        <TabPanel>
                            <CatalogGroup catalogSource={getCatalogSource(tipoArticulos.LentesEsclerales)} />
                        </TabPanel>



                    </Tabs>


                </Item>

            </Box>

        </div>
    );
}

export default MasterCatalogs;